<template>
  <div>
    <list
      row-key="OrderId"
      ref="list"
      unit="订单"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel() && !isDialog"
      :show-query="false"
      :get-data-func="api.list"
      @reset-query="$emit('reset-select')"
      append-to-body
      :show-toolbar="false"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query" v-if="false">
        <el-form-item label="订单编号">
          <el-input
            size="mini"
            v-model="params.OrderNo"
            placeholder="请输入订单编号"
            clearable
          />
        </el-form-item>
        <el-form-item label="用户昵称">
          <el-input
            size="mini"
            v-model="params.NickName"
            placeholder="请输入用户昵称"
            clearable
          />
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-input
            size="mini"
            v-model="params.ContactPhone"
            placeholder="请输入用户手机号"
            clearable
          />
        </el-form-item>

        <el-form-item label="订单时间">
          <el-date-picker
            size="mini"
            v-model.trim="params.StartTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin: 0 10px">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.EndTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item>
      
      </template>
      <template slot="table">
        <el-table-column label="序号" align="center" type="index" width="50">
        </el-table-column>
       
        <el-table-column prop="NickName" label="昵称" align="center">
          <template slot-scope="{ row }">
            <span style="display: block; color: #409eff">{{
              row.NickName
            }}</span>
          </template>
        </el-table-column>
       
        <el-table-column prop="ContactPhone" label="手机号码" align="center">
          <template slot-scope="{ row }">
            <span style="display: block; color: #409eff">{{
              row.ContactPhone
            }}</span>
          </template>
        </el-table-column>       
        <el-table-column prop="OrderNo" label="缴费微信订单号" width="200px">
          <template slot-scope="{ row }">
            <span
              style="display: block; color: #409eff"
              v-clipboard:copy="row.OrderNo"
              v-clipboard:success="copySuccess"
              v-clipboard:error="copyError"
              >{{ row.OrderNo }}<i class="el-icon-copy-document"></i
            ></span>
          
          </template>
        </el-table-column>
      
        <el-table-column prop="SubTotal" label="缴费金额" align="center">
          <template slot-scope="{ row }">
            <span style="display: block; text-align: center; color: red">{{
              "¥" + Number(row.SubTotal || 0).toFixed(2)
            }}</span>
          
          </template>
        </el-table-column>
      
        <el-table-column prop="OrderDate" label="缴费时间" align="center">
          <template slot-scope="{ row }">
              <span>{{ row.OrderDate }}</span>
          
          </template>
        </el-table-column>
       
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
export default {
  mixins: [listMixin],
  components: { list },
  props: {
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api: require("@/api/sale/order/order").default,
      params: {
        OrderNo: "",
        OrderState: null, //订单状态
        SendState: null, //发货状态
        PayState: null, //付款状态
        RefundState: null, //退款状态
        AfterSalesState: null, //售后状态
        ReceivingPerson: "",
        ReceivingPhone: "",
        PersonName: "",
        ShowType: 1, //0所有，1不显示父级订单
        BusiName: "",
        OrderStates: [4],
        OrderMode:1,
        GoodsId:null
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  mounted() {
    if (this.$route.query.state == 1) {
      this.params.OrderState = 1;
      this.query(this.params);
    } else if (this.$route.query.state == 2) {
      this.params.OrderState = 2;
      this.query(this.params);
    } else if (this.$route.query.state == 3) {
      this.params.OrderState = 5;
      this.query(this.params);
    }
  },
  methods: {
    changeState(val) {
      this.params.OrderState = val;
      if (val == null || val == "") {
        this.params.OrderStates = [0, 1, 2, 3, 4, 6];
      } else {
        this.params.OrderStates = [val];
      }
      this.query(this.params);
    },
    copySuccess() {
      this.$message.success("复制成功");
    },
    copyError() {
      this.$message.error("复制失败");
    },
    rowStyle({ row, index }) {
      return "border:0";
    },
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        resolve({ Count: 0, Data: [{ RecordId: 1 }] });
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.gtable .el-table__cell {
  border: 0;
}
</style>